import { call, put, select, all } from 'redux-saga/effects';
import request from './request';
import deltas from '../../redux/actions/deltas';
import { findWithFuzzySearch } from '../../api';

const {
    setFuzzySearchResults,
} = deltas.actionCreators;

const options = {
    notificationOnFailure: {
        generateMessage: message => 'There was a problem with the fuzzy search',
    }
};

export default function* performFuzzySearch({ columnName, searchValue }) {
    const state = yield select();

    if ('' === searchValue) {
        // Empty search, no need to make a call
        yield put(setFuzzySearchResults(columnName, []));
        return;
    }

    const {
        results: {response: {data: results}}
    } = yield all({
        results: call(request, ...[findWithFuzzySearch, options, {}, null, { 'columnName': `${columnName}`, 'value': `${searchValue}` }])
    });

    yield put(setFuzzySearchResults(columnName, results));
}
